export default "__VITE_ASSET__CEq_oza0__"